"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = part;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * Vraci objekt slozeny s nazvu fieldu a doplnene hodnoty.
 *
 * @param {string} fieldName
 * @param {*} value
 *
 * @returns {Object}
 */
function part(fieldName, value) {
  return (0, _defineProperty2.default)({}, fieldName, value);
}